import axiosInstance from "api/api"
import { Endpoint } from "api/enpoints.types"
import { AxiosError, AxiosResponse } from "axios"
import { useQuery } from "react-query"

import {
  IGetShortClassListArgs,
  IGetShortClassListResponse,
} from "./shortClassList.types"

export const useQueryShortClassList = ({
  classId,
  limit,
  page,
  sorting,
  sort_by,
  filter,
  options,
}: IGetShortClassListArgs) =>
  useQuery<AxiosResponse<IGetShortClassListResponse>, AxiosError>(
    ["shortClassList", classId, limit, page, sorting, sort_by, filter],
    async () =>
      axiosInstance(
        Endpoint.CLASSES_ID_STUDENTS_SHORT.replace("ID", `${classId}`),
        {
          params: {
            limit,
            page,
            sorting,
            sort_by,
            filter,
          },
        }
      ),
    options
  )
